<template>
  <div class="report">
    <div>
      <p class="title">入库单</p>
      <p>
      日期
      <el-date-picker
        v-model="from9.date"
        align="right"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
        >
      </el-date-picker>
      </p>

      司机
      <el-select v-model="from9.driver" filterable placeholder="请选择司机">
        <el-option
          v-for="item in driver_options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport9" >打印</el-button>
      </p>
    </div>


    <div>
      <p class="title">运送登记卡</p>
      <!--<span class="demonstration"></span>-->


      <p>日期
      <el-date-picker
        v-model="from7.date"
        align="right"
        type="date"
        placeholder="选择日期"
        value-format="yyyy-MM-dd"
      >
      </el-date-picker>
      </p>

      <p>司机
      <el-select v-model="from7.driver" filterable placeholder="请选择司机">
        <el-option
          v-for="item in driver_options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport7" >打印</el-button>
      </p>
    </div>

    <div>
      <p class="title">月报表</p>

      <p>月份

      <el-date-picker
        v-model="from1.date"
        type="month"
        value-format="yyyy-MM-dd"
        placeholder="选择月">
      </el-date-picker>
      </p>

      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport1" >打印</el-button>
      </p>
    </div>


    <div>
      <p class="title">年报表</p>
      <p>年份
      <el-date-picker
        v-model="from2.date"
        type="year"
        value-format="yyyy-MM-dd"
        placeholder="选择年">
      </el-date-picker>
      </p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport2" >打印</el-button>
      </p>
    </div>

    <div>
      <p class="title">转运联单</p>
      <p>月份
      <el-date-picker
        v-model="from21.date"
        type="month"
        value-format="yyyy-MM-dd"
        placeholder="选择月">
      </el-date-picker>
      </p>
      <p>医院
      <el-select v-model="from21.hospital" filterable placeholder="请选择医疗企业" style="width: 350px">
        <el-option
          v-for="item in hospitals"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport21" >打印</el-button>
      </p>
    </div>
    <div>
      <p class="title">线路月转运联单</p>
      <p>月份
        <el-date-picker
          v-model="from22.date"
          type="month"
          value-format="yyyy-MM-dd"
          placeholder="选择月">
        </el-date-picker>
      </p>
      <p>线路
        <el-select v-model="from22.area" filterable placeholder="请选择线路">
          <el-option
            v-for="item in line_num"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport22" >打印</el-button>
      </p>
    </div>
    <div>
      <p class="title">医院年报表</p>
      <p>年份
      <el-date-picker
        v-model="from3.year"
        type="year"
        value-format="yyyy"
        placeholder="选择年">
      </el-date-picker>
      </p>
      <p>线路
      <el-select v-model="from3.area" filterable placeholder="请选择线路">
        <el-option
          v-for="item in line_num"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      </p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport3" >打印</el-button>
      </p>
    </div>

    <div>
      <p class="title">线路月报表</p>
      <p>月份
        <el-date-picker
          v-model="from4.date"
          type="month"
          value-format="yyyy-MM"
          placeholder="选择月">
        </el-date-picker>
      </p>
      <p>线路
        <el-select v-model="from4.area" filterable placeholder="请选择线路">
          <el-option
            v-for="item in line_num"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>
      </p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport4" >打印</el-button>
      </p>
    </div>

    <div>
      <p class="title">出入登记</p>
      <p>日期
        <el-date-picker
          v-model="from8.date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期">
        </el-date-picker>
      </p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport8" >打印</el-button>
      </p>
    </div>

    <div>
      <p class="title">领用发放物报表</p>
      <p>
        月份
        <el-date-picker
          v-model="from5.date"
          align="right"
          type="month"
          placeholder="选择月份"
          value-format="yyyy-MM"
        >
        </el-date-picker>
      </p>

      司机
      <el-select v-model="from5.driver" filterable placeholder="请选择司机">
        <el-option
          v-for="item in driver_options"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport5" >打印</el-button>
      </p>
    </div>
    <div>
      <p class="title">发放物统计报表</p>
      <p>
        <el-date-picker
          v-model="from23.date"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          format="yyyy-MM-dd"
          end-placeholder="结束日期">
        </el-date-picker>
      </p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p> &nbsp;</p>
      <p>
        <el-button type="primary" icon="el-icon-printer" @click="openReport23" >打印</el-button>
      </p>
    </div>
  </div>

</template>
<script>
  import coder from "./enum.js"
  // import power from "./power.js"
  // let url={0:"/report/grant",1:"/report/in-out",2:"/report/out",3:"/report/grant1",
  //   4:"/report/year",5:"/report/in",6:"/report/month",
  //   7:"/report/dangerous",8:"/report/year",9:"/report/month1",10:"/report/dangerous"};
export default {
  name: "Report",
  data(){
    return{
      from9:{
        date:'',
        driver:'',
      },
      from8:{
        date:'',
      },
      from7:{
        date:'',
        driver:'',
      },
      from1:{
        date:'',
      },
      from2:{
        date:'',
      },
      from3:{
        year:'',
        area:'',
      },
      from4:{
        date:'',
        area:'',
      },
      from5:{
        date:'',
        driver:'',
      },
      from21:{
        date:'',
        hospital:'',
      },
      from22:{
        date:'',
        area:'',
      },
      from23:{
        date:'',
      },
      car_id_options: [{
        value: '川A:12345',
        label: '川A:12345'
      }, {
        value: '川A:11111',
        label: '川A:11111'
      }, {
        value: '川A:22222',
        label: '川A:22222'
      }, {
        value: '川A:23456',
        label: '川A:23456'
      }, {
        value: '川A:34567',
        label: '川A:34567'
      }],
      car_id_value: '',

      line_num:[{
        value: '1',
        label: '1'
      },{
        value: '2',
        label: '2'
      },{
        value: '3',
        label: '3'
      },{
        value: '4',
        label: '4'
      },{
        value: '5',
        label: '5'
      },{
        value: '6',
        label: '6'
      },{
        value: '7',
        label: '7'
      },{
        value: '8',
        label: '8'
      },{
        value: '9',
        label: '9'
      },{
        value: '10',
        label: '10'
      },{
        value: '11',
        label: '11'
      },{
        value: '12',
        label: '12'
      },{
        value: '13',
        label: '13'
      },{
        value: '14',
        label: '14'
      },{
        value: '15',
        label: '15'
      }],
      line_options: [{
        value: '乐山',
        label: '乐山'
      }, {
        value: '夹江',
        label: '夹江'
      }, {
        value: '金口河',
        label: '金口河'
      }, {
        value: '峨眉山',
        label: '峨眉山'
      }, {
        value: '五通桥',
        label: '五通桥'
      }],
      line_value: '',
      hospitals:[],
      allArea:[],
      driver_options: [{
        value: '张三',
        label: '张三'
      }, {
        value: '李四',
        label: '李四'
      }, {
        value: '王麻子',
        label: '王麻子'
      }, {
        value: '川建国',
        label: '川建国'
      }, {
        value: '路人甲',
        label: '路人甲'
      }],
    }
  },
  mounted(){
    let $this=this;
    window.ws.AddFunc("S2W_CarAndLineAndDriverRes",function(code,err,cars,lines,drivers){
      if (code===coder.OK) {
        let carIDs = [];
        for(let i=0;i<cars.length;i++){
          carIDs.push({value:cars[i],label:cars[i]})
        }
        $this.car_id_options=carIDs;
        // $this.setData({car_id_options:carIDs});

        let lineArr = [];
        for(let i=0;i<lines.length;i++){
          lineArr.push({value:lines[i],label:lines[i]})
        }
        $this.line_options = lineArr;
        // $this.setData({line_options :lineArr});

        let driverArr = [];
        for(let i=0;i<drivers.length;i++){
          driverArr.push({value:drivers[i],label:drivers[i]})
        }
        $this.driver_options = driverArr
        // $this.setData({driver_options:driverArr});
      }else{
        $this.$alert(err+'('+code+')', '错误', {
          confirmButtonText: '确定'
        });
      }
    });
    window.ws.Call("W2S_CarAndLineAndDriver");


    if (window.hospitals===null||window.hospitals===undefined||window.hospitals.length===0) {
      window.ws.AddFunc("S2W_GetHospitalNamesRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],list:list[i]})
        }
        $this.hospitals=names;
        window.hospitals=names;
      });
      console.log("W2S_GetHospitalNames");
      window.ws.Call("W2S_GetHospitalNames");
    }else{
      this.hospitals=window.hospitals
    }

    if (window.allArea===null||window.allArea===undefined||window.allArea.length===0){

      window.ws.AddFunc("S2W_GetAllAreaRes",function(list){
        let names = [];
        for(let i=0;i<list.length;i++){
          names.push({value:list[i],list:list[i]})
        }
        $this.allArea=names;
        window.allArea=names;
      });

      window.ws.Call("W2S_GetAllArea")
    }else{
      this.allArea=window.allArea;
    }


  },
  methods: {
    openReport1(index){
      if (this.from1.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report1Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/month",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report1",this.from1.date);
    },
    openReport2(index){
      if (this.from2.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report2Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/month",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report2",this.from2.date);
    },
    openReport3(index){
      if (this.from3.year===''){
        this.$alert('请选择年份', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from3.area===''){
        this.$alert('请选择区域', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report3Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/year",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report3",this.from3.year,this.from3.area);
    },
    openReport4(index){
      if (this.from4.date===''){
        this.$alert('请选择月份', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from4.area===''){
        this.$alert('请选择区域', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report4Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/month1",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report4",this.from4.date,this.from4.area);
    },
    openReport5(index){
      if (this.from5.date===''){
        this.$alert('请选择月份', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from5.driver===''){
        this.$alert('请选择区域', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report5Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/grant1",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report5",this.from5.date,this.from5.driver);
    },
    openReport21(index){
      if (this.from21.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from21.hospital===''){
        this.$alert('请选择医疗机构', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report21Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/dangerous",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report21",this.from21.date,this.from21.hospital);
    },
    openReport22(index){
      if (this.from22.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from22.area===''){
        this.$alert('请选择区域', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report22Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/dangerous",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report22",this.from22.date,this.from22.area);
    },
    openReport7(index){
      if (this.from7.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from7.driver===''){
        this.$alert('请选择驾驶员', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report7Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/transfer",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report7",this.from7.date,this.from7.driver);
    },
    openReport8(index){
      if (this.from8.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report8Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/in-out",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report8",this.from8.date);
    },
    openReport9(index){
      if (this.from9.date===''){
        this.$alert('请选择日期', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      if (this.from9.driver===''){
        this.$alert('请选择驾驶员', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report9Res",function(key){
        const params = { key:key ,userName:window.userName};
        let routeData = $this.$router.resolve({
          path: "/report/in",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      window.ws.Call("W2S_Report9",this.from9.date,this.from9.driver);
    },
    openReport(index){
      const params = { id: 111,name:"乐山市人民医院",time:"20201206",type:1,start:1,end:10 };
      let routeData = this.$router.resolve({
        path: "/report/in",
        query: params,
      });
      window.open(routeData.href, '_blank');
    },
    openReport23(index){
      //
      if (this.from23.date===''){
        this.$alert('请选择日期范围', '错误', {
          confirmButtonText: '确定'
        });
        return
      }
      let $this=this;
      window.ws.AddFunc("S2W_Report23Res",function(key){
        const params = { key:key };
        let routeData = $this.$router.resolve({
          path: "/report/grantSum",
          query: params,
        });
        window.open(routeData.href, '_blank');
      });
      try {
        window.ws.Call("W2S_Report23", this.dateFormat("YYYY-mm-dd", this.from23.date[0]), this.dateFormat("YYYY-mm-dd", this.from23.date[1]));
        console.log("日期范围：",this.dateFormat("YYYY-mm-dd",this.from23.date[0]),this.dateFormat("YYYY-mm-dd",this.from23.date[1]))
      }catch (e) {
        this.$alert('日期范围选择错误：'+e, '错误', {
          confirmButtonText: '确定'
        });
      }
    },
    dateFormat(fmt, date) {
      let ret;
      const opt = {
        "Y+": date.getFullYear().toString(),        // 年
        "m+": (date.getMonth() + 1).toString(),     // 月
        "d+": date.getDate().toString(),            // 日
        "H+": date.getHours().toString(),           // 时
        "M+": date.getMinutes().toString(),         // 分
        "S+": date.getSeconds().toString()          // 秒
        // 有其他格式化字符需求可以继续添加，必须转化成字符串
      };
      for (let k in opt) {
        ret = new RegExp("(" + k + ")").exec(fmt);
        if (ret) {
          fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
        };
      };
      return fmt;
    },
  }
}
</script>
<style scoped>
  .report{
    /*//width: 910px;*/
    text-align: left;
  }
  .report>div{
    line-height: 5px;
    font-size: 12px;
    display: inline-block;
    width: 400px;
    height: 200px;
    margin-right:15px;
    margin-top: 15px;
    padding-left: 10px;
    padding-right: 10px;
    border: 1px solid #ccc;
  }
  .report>el-button{
    width: 400px;
  }
  .title{
    font-size: 20px;
  }
  /*.report>div:last-child{margin-right: 0 !important;}*/
  /*.report>div>span{display: block;width: 100%}*/

  /*.report>div>span>label:last-child{display: inline-block;text-align: right;width: calc(100% - 60px)}*/
  /*.report>div>span>label:first-child{display: inline-block;width: 50px}*/
  /*.report>div>div{margin-top: 5px;margin-bottom: 5px;margin-left: 10px}*/


</style>



// WEBPACK FOOTER //
// src/view/report.vue